import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { roomsDataProvider } from './dataProvider';

export function initSocialTradingRoomsDataProvider() {
  registerModuleDataProvider(Resources.socialTradingRooms, roomsDataProvider);
}

initSocialTradingRoomsDataProvider();
